import { addNewFlow, saveFlows } from '../actions/flows'
import { saveAtoms } from '../actions/atoms'

import { alertError, alertSuccess, createJsonHeaders, logoutOnRequestOrResponseJson } from '../../../api'

import { PRIVATE_BASE_URL } from '../../../configs'

export const getFlows = botId => {
  fetch(PRIVATE_BASE_URL + '/bot/' + botId + '/flow', {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'GET',
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(json => {
      saveFlows(json)
      saveAtoms(json)
    })
    .catch(() => {
      alertError('Sorry but something is going wrong please ping support!')
    })
}

export function createNewFlow(botId, flow) {
  fetch(PRIVATE_BASE_URL + '/bot/' + botId + '/flow', {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'POST',
    body: JSON.stringify(flow),
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(json => {
      alertSuccess('Flow is created successfully.')
      addNewFlow(json)
    })
    .catch(() => {
      alertError('Fail. Try it later')
    })
}

export function deleteFlow(flowId, botId, callback) {
  fetch(PRIVATE_BASE_URL + '/bot/' + botId + '/flow/' + flowId, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'DELETE',
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(() => {
      alertSuccess('Flow is deleted successfully.')
      getFlows(botId)
      callback()
    })
    .catch(() => {
      alertError('Fail. Try it later')
    })
}

export function changeFlowStatus(flowId, botId, disable) {
  fetch(PRIVATE_BASE_URL + '/flow/' + flowId + '?disable=' + disable, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'PUT',
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(() => {
      alertSuccess('Flow status is changed successfully.')
      getFlows(botId)
    })
    .catch(() => {
      alertError('Fail. Try it later')
    })
}
